import { render, staticRenderFns } from "./RingButton.vue?vue&type=template&id=73642cbc&scoped=true"
import script from "./RingButton.vue?vue&type=script&lang=js"
export * from "./RingButton.vue?vue&type=script&lang=js"
import style0 from "./RingButton.vue?vue&type=style&index=0&id=73642cbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73642cbc",
  null
  
)

export default component.exports